import React, { ReactNode } from 'react';

interface Props {
    type?: string;
    url: string;
    children: ReactNode;
    isLiveMode?: boolean;
}

const DesignLink: React.FC<Props> = ({ type, url, children, isLiveMode }) => {
    const generateUrl = (url: string | null, type?: string) => {
        if (!url) {
            return '';
        }
        switch (type) {
            case 'email':
                return `mailto:${url}`;
            case 'phone':
                return `tel:${url.replace(/[-\(\) ]/g, '')}`;
            case 'address':
                const uri = encodeURIComponent(url);
                return `https://www.google.com/maps/search/?api=1&query=${uri}`;
            default:
                if (!url.startsWith('http')) {
                    url = `http://${url}`;
                }
                return url;
        }
    };
    return isLiveMode ? (
        <a target="_blank" rel="noopener noreferrer" href={generateUrl(url, type)}>
            {children}
        </a>
    ) : (
        <>{children}</>
    );
};

export default DesignLink;
